package org.ksdfv.thelema.kxjs.audio

import org.ksdfv.thelema.audio.*
import org.ksdfv.thelema.fs.IFile

/** @author zeganstyl */
class JsAL: IAL {
    val context = AudioContext()

    override fun newAudioDevice(samplingRate: Int, channelsNum: Int): IAudioDevice =
        JsAudioDevice(this, samplingRate, channelsNum)

    override fun newAudioRecorder(samplingRate: Int, isMono: Boolean): IAudioRecorder {
        TODO("Not yet implemented")
    }

    override fun newSound(file: IFile): ISound = JsSound(this, file.path)

    override fun newMusic(file: IFile): IMusic = JsSound(this, file.path)

    override fun getVersion(param: Int): String = "Web Audio API"

    override fun update() {}

    override fun destroy() {
        context.close()
    }
}
